// src/components/onboarding/OnboardingSidebar.tsx
import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { BarChart, Bot, ArrowRight, CheckCircle } from "lucide-react";

const adventureOptions = [
  {
    title: "Find Quick Wins",
    description: "Review the fastest ways to improve performance.",
    icon: <CheckCircle className="w-6 h-6 mr-4 text-primary" />,
    link: "/onboarding/quick-wins",
  },
  {
    title: "Explore Simple Tools",
    description: "Analyze your campaigns with simplified tools.",
    icon: <BarChart className="w-6 h-6 mr-4 text-primary" />,
    link: "/onboarding/tools-choice",
  },
  {
    title: "Get AI Insights",
    description: "Ask our AI for custom recommendations.",
    icon: <Bot className="w-6 h-6 mr-4 text-primary" />,
    link: "/onboarding/ai-setup",
  },
  {
    title: "Dive into Advanced Features",
    description: "Explore the full power of the 8020agent platform.",
    icon: <ArrowRight className="w-6 h-6 mr-4 text-primary" />,
    link: "/onboarding/benefits",
  },
];

export const OnboardingSidebar = () => {
  return (
    <aside className="w-1/4 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>What's Next?</CardTitle>
          <CardDescription>
            Explore other areas or finish onboarding.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {adventureOptions.map((option) => (
            <Link
              to={option.link}
              key={option.title}
              className="block hover:bg-muted/50 p-4 rounded-lg transition-colors"
            >
              <div className="flex items-center">
                {option.icon}
                <div>
                  <h4 className="font-semibold">{option.title}</h4>
                  <p className="text-sm text-muted-foreground">
                    {option.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </CardContent>
      </Card>
    </aside>
  );
};

export default OnboardingSidebar;
